module.exports = __webpack_public_path__ + "static/media/best-burger-ever-burger-desktop-en.c615859d.jpg";